// extracted by mini-css-extract-plugin
module.exports = {"homeLink":"TextPage_homeLink__3Ozst","heading":"TextPage_heading__Bsj8N"};